import type React from "react";

export const UnrecognizedChainIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.75004 5.83325L9.00004 9.99992M9.00004 9.99992L16.25 5.83325M9.00004 9.99992L9 18.3333M16.5 6.6665C16.4997 6.37423 16.4225 6.08718 16.2763 5.83414C16.13 5.5811 15.9198 5.37097 15.6667 5.22484L9.83333 1.8915C9.57997 1.74522 9.29256 1.66821 9 1.66821C8.70744 1.66821 8.42003 1.74522 8.16667 1.8915L2.33333 5.22484C2.08022 5.37097 1.86998 5.5811 1.72372 5.83414C1.57745 6.08718 1.5003 6.37423 1.5 6.6665V13.3332C1.5003 13.6254 1.57745 13.9125 1.72372 14.1655C1.86998 14.4186 2.08022 14.6287 2.33333 14.7748L8.16667 18.1082C8.42003 18.2545 8.70744 18.3315 9 18.3315C9.29256 18.3315 9.57997 18.2545 9.83333 18.1082L15.6667 14.7748C15.9198 14.6287 16.13 14.4186 16.2763 14.1655C16.4225 13.9125 16.4997 13.6254 16.5 13.3332V6.6665Z"
      stroke="#737373"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
